// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__yzDC2","checkmark":"Checkbox_checkmark__GTdP6"};